





import { Component } from 'vue-property-decorator';
import Mixin from '../../mixin';

@Component({
  name: 'v-back-button'
})
export default class VBackButton extends Mixin {}
